import axios from "axios";

class BrochueApi {

  getBrochure(): Promise<string> {
    const apiUrl = "/api/v1/brochure";

    return axios.get(apiUrl)
    .then(response => {
      const brochureUrl = response.data.url;
      return Promise.resolve(brochureUrl);
    })
  }

}

export default BrochueApi;